<template>
  <button class="confirmation__close" @click="closeDialog" aria-label="Dialog schließen">
    <IconClose aria-hidden="true" />
  </button>
  <h2 class="confirmation__title" id="dialog-title">Termin bestätigen</h2>

  <!-- Error message -->
  <div
    v-if="hasError"
    class="error-message"
    role="alert"
    aria-live="assertive"
    aria-labelledby="error-title"
  >
    <p id="error-title">
      Beim Buchen des Termins ist ein Fehler aufgetreten, versuchen Sie es später noch einmal.
    </p>
  </div>

  <p class="confirmation__subtitle" id="dialog-subtitle">
    Bitte bestätigen Sie den Termin für Ihre kostenlose Beratung:
    <strong>{{
      formatDateTime('day, dateLong, timeFrom Uhr', new Date(selectedTimeslot?.startsAt))
    }}</strong>
  </p>
  <div class="confirmation__buttons" role="group" aria-label="Aktionen">
    <Button label="Abbrechen" outline @clicked="closeDialog" aria-describedby="dialog-subtitle" />
    <Button
      :label="isBookingInProgress ? 'Wird gebucht...' : 'Termin bestätigen'"
      :disabled="isBookingInProgress"
      @clicked="handleBooking"
      :aria-describedby="hasError ? 'error-title' : 'dialog-subtitle'"
    />
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
import IconClose from '@/components/icons/IconClose.vue'
import { formatDateTime } from '@/utils/format'

export default {
  components: { IconClose, Button },
  props: {
    selectedTimeslot: {
      type: Object || null,
      required: true,
    },
    isBookingInProgress: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['closeDialog', 'bookConsultation'],
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    handleBooking() {
      this.$emit('bookConsultation')
    },
    formatDateTime,
  },
}
</script>

<style lang="scss">
// Uses the same confirmation styles as other dialogs in the app

.error-message {
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  background-color: #fff3f3;
  color: #d32f2f;
  border: 1px solid #ffcdd2;

  // Enhanced focus styling for screen readers
  &:focus-within {
    outline: 2px solid #d32f2f;
    outline-offset: 2px;
  }

  p {
    margin: 0;
    font-weight: 500;
  }
}

// Improve focus visibility for close button
.confirmation__close {
  &:focus {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
}
</style>
